
import TextArea from "./TextArea";
import "./InputArea.css"
import { useSelector,useDispatch } from "react-redux";
import { nextStep } from "../../actions";
import { Link } from "react-router-dom";

const InputArea = () => {

    const day = useSelector(state => state.day)
    const file = useSelector(state => state.file)
    const dispatch = useDispatch()

    const handleCreate = () => {
        console.log(file)
        if (!(day && file)){
            showWarning(day, file)
            return null
        } 
        dispatch(nextStep())
    }

    const showWarning = () => {
        if (!file){
            const uploadArea = document.querySelector(".UploadArea")
            uploadArea.classList.add("alert")
            setTimeout(()=>{
                uploadArea.classList.remove("alert")
            },2000)
        }
        if (!day){
            const buttons = document.querySelectorAll(".DayButtons button")
            buttons.forEach(button => button.classList.add("alert"))
            setTimeout(()=>{
                buttons.forEach(button => button.classList.remove("alert"))
            },2000)
        }
    }

    return(
        <div className="InputArea">
            <div>
                <TextArea/>
                <Link to={"/about"} className="aboutLink">About our Team</Link>
            </div>
            
            <button onClick={handleCreate}>Create</button>
        </div>
    )
}

export default InputArea